import axios from 'axios';
import React, { useRef, useState } from 'react';
import { Button , Col, Form, Row } from 'react-bootstrap';

const UserInput = () => {

    const [users,setUsers]= useState([])
    const nameRef = useRef()
    const phRef = useRef()
    const emailRef = useRef()
    const address1Ref = useRef()
    const address2Ref = useRef()
    const cityRef = useRef()
    // const stateRef = useRef()
    const zipRef = useRef()

    const handleUserInput=(e)=>
    {
        
        e.preventDefault()
        const name = nameRef.current.value;
        const email = emailRef.current.value;
        const ph = phRef.current.value;
        const address1 = address1Ref.current.value;
        const address2 = address2Ref.current.value;
        const city = cityRef.current.value;
        const zip = zipRef.current.value;
        const userdetail = {name,email,ph,address1,address2,city,zip}
          
        
        const Url= 'https://damp-sands-37964.herokuapp.com/userInput';
              
        axios.post(Url,userdetail).then(res=> {
          console.log(res)
          if (res.data.insertedId) {
            alert('Successfully Saved the User Data')
            e.target.reset();
        }
        })
        .catch(function (error) {
          console.log(error);
        });



        // fetch(Url,
        //    {
        //        method:'post',
        //        headers:{
        //            'Content-Type': 'application/json'
        //        },
        //        body: JSON.stringify(userdetail) 
        //    })
        //    .then(response => response.json())
        //    .then(data => {
        //      if (data.insertedId) {
        //          alert('Successfully Saved the User Data')
        //          e.target.reset();
        //      }
        //    })
        //    .catch(error => {
        //      console.error('Error:', error);
        //    });


        // setUsers(userdetail)
        //console.log(users);
    }
    

    return (
        <div className="container mt-5 p-4">
            <div className="col-4"></div>
            <div className="col-12 col-md-6 col-lg-4 mx-auto">
            <Form onSubmit={handleUserInput}>
        <Row className="mb-3">
          <Form.Group as={Col} controlId="formGridEmail">
            <Form.Label>Email</Form.Label>
            <Form.Control  ref={emailRef} type="email" placeholder="Enter email" />
          </Form.Group>
      
          <Form.Group as={Col} controlId="formGridPassword">
            <Form.Label>Phone</Form.Label>
            <Form.Control ref={phRef} type="text" placeholder="+880 ***********" />
          </Form.Group>
        </Row>
          <Form.Group  controlId="formGridPassword">
            <Form.Label>Your Full Name</Form.Label>
            <Form.Control ref={nameRef} type="text" placeholder="Name" />
          </Form.Group>
        
      
        <Form.Group className="mb-3" controlId="formGridAddress1">
          <Form.Label>Address</Form.Label>
          <Form.Control ref={address1Ref} placeholder="1234 Main St" />
        </Form.Group>
      
        <Form.Group className="mb-3" controlId="formGridAddress2">
          <Form.Label>Appointment Cause</Form.Label>
          <Form.Control ref={address2Ref}  placeholder="Simply write your Problem" />
        </Form.Group>
      
        <Row className="mb-3">
          <Form.Group as={Col} controlId="formGridCity">
            <Form.Label>City</Form.Label>
            <Form.Control ref={cityRef} />
          </Form.Group>
      
         
      
          <Form.Group as={Col} controlId="formGridZip">
            <Form.Label>Zip</Form.Label>
            <Form.Control ref={zipRef} />
          </Form.Group>
        </Row>
      
        {/* <Form.Group className="mb-3" id="formGridCheckbox">
          <Form.Check type="checkbox" label="Check me out" />
        </Form.Group> */}
      
        <Button variant="primary" type="submit">
          Submit
        </Button>
      </Form>
            </div>
            <div className="col-4"></div>
        </div>
    );
};

export default UserInput;